module.exports = __webpack_public_path__ + "img/warning.0c8ce859.svg";